<template>
  <div>
    <div class="product-container">
      <Bread first-name="系统平台" metertype="智慧水务管理平台"></Bread>
      <el-tag effect="dark">智慧水务系统简介</el-tag>
      <div class="sys-synopsis">
        智慧水务云平台主要用于对卡表信息进行管理，并为用户建立信息档案，可完成开户缴费等操作，提高收费可控性。
      </div>
      <el-tag effect="dark">系统功能简介</el-tag>
      <div class="sys-synopsis">
        <span>
          用户管理： 用户的注册，修改密码等 设备管理：
          对设备名称、设备编码、所属不同区域等不同信息进行管理； 客户信息管理：
          对供水部门、城市、小区、楼栋、用户、水表等信息进行管理； 报表系统：
          基本信息查询，用户供水状态实时查询，用水历史信息查询，缴费历史查询；
          安全控制：
          根据管理及安全需要，为各级操作员配置不同操作权限，保障系统安全。
        </span>
      </div>
      <el-tag effect="dark">系统特点简介</el-tag>
      <div class="sys-synopsis">
        安全性：
        数据管理服务器、远程通讯管理服务器和终端用户管理软件分离设计，保证数据安全，完整的权限系统，支持修改各个角色的权限；
        便捷性： 支持补卡换表，灵活操作； 扩展性：
        可以根据用户的要求对系统进行定制开发，终端软件远程升级，以满足不同用户的各项新增需求
      </div>
      <div class="system-img">
        <img src="@/svg/sys_1.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/sys_2.png" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.product-container {
  .el-tag {
    margin-top: 20px;
    height: 40px;
    font-size: 20px;
  }
  .sys-synopsis {
    line-height: 35px;
    letter-spacing: 2px;
    text-indent: 1cm;
    padding: 12px 0;
    font-size: 18px;
  }
  .system-img {
    height: 670px;
    width: 1150px;
    padding-top: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
